import { useTranslation } from 'react-i18next'
import LabeledValue from '@/components/labeled-value'
import { isNullOrEmpty } from '@/utils'
import formatCurrency from '@/utils/format-currency'
import formatDate from '@/utils/format-date'
import formatPaymentFrequency from '@/utils/format-payment-frequency'

const TextField = ({ item, value, type, label }) => {
  const { t } = useTranslation()

  const formattedValue = () => {
    switch (type) {
      case 'date':
        return formatDate(value, 'YYYY/MM/DD')
      case 'currency':
        return formatCurrency(value)
      case 'price_frequency':
        return formatPaymentFrequency(value, t)
      default:
        return value
    }
  }
  if (!label) return formattedValue()
  return <LabeledValue label={t(`b.contract.view.${item.name}.label`)} value={formattedValue()} />
}

const renderTextField = ({
  item,
  contract,
  value = null,
  type = 'text',
  label = true,
  ...rest
}) => {
  const fieldValue = value || contract[item.name]

  if (isNullOrEmpty(fieldValue)) return null

  return <TextField key={item.name} item={item} value={fieldValue} type={type} label={label} />
}

export default renderTextField
